<script lang="ts">
    import { Tomorrow } from "../../../utils/Constant/Constant";

</script>
<div class="media">
    <div class="media-body d-block">
        <div class="tomorrow-sec">
            <p>{Tomorrow}</p>
        </div>
    </div>
</div>